import styled from "styled-components";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

export const Wrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  border: 1px solid;
  border-radius: 8px;
  border-color: ${(props: {
    $isSecondaryBackground: boolean;
    $hasError: boolean;
    $height?: string;
    $showPhoneCode?: boolean;
  }) => (props.$hasError ? "#f9123b" : "#E9E9E9")} !important;
  height: ${(props) => props.$height ?? "48px"};

  :hover {
    border-color: #a3a3a3 !important;
  }

  :focus-within {
    border-color: #000000 !important;
  }
  & p {
    height: 100%;
    display: flex;
    align-items: center;
    background-color: ${(props) =>
      props.$isSecondaryBackground ? "#fffbf7" : "#ffffff"};
    color: ${(props) => (props.$hasError ? "#f9123b" : "#a3a3a3")};
    transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1),
      opacity 150ms cubic-bezier(0.4, 0, 0.2, 1);
    &.input-label {
      font-family: "Inter";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      color: #8D8D8D;
      position: absolute;
      top: 0px;
      left: 66px;
      margin: 0;
      margin-left: ${(props) => (props.$showPhoneCode ? "32px" : "0px")};
      padding: 0;
      &.has-value {
        z-index: -1;
      }
      &.top {
        height: max-content;
        font-size: 12px;
        line-height: 16px;
        color: #A3A3A3;
        transform: ${(props) => (props.$showPhoneCode ? "translate(-84px, -8px)" : "translate(-52px, -8px)")};
        padding: 0 2px;
        z-index: 0;
      }
    }
  }

  & input {
    padding: 8px 14px;
    font-weight: 400;
    font-size: 16px;
    line-height: 160%;
    width: 100%;
    box-sizing: border-box;
    background-color: transparent;
    border: none;
    outline: none;
  }

  & input::placeholder {
    font-family: "Inter";
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    color: #8D8D8D !important;
  }
`;
export const CountryCodeSpan = styled.span`
  position: absolute;
  left: 40px;
  top: 8px;
  max-width: 36px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #a39d9e;
`;
export const PhoneInputWrapper = styled(PhoneInput)`
  display: flex;
  width: 100%;
  position: relative;
  background: transparent;
  & .PhoneInputCountryIcon {
    height: 24px;
    width: 24px;
    box-shadow: none;
    background: transparent;
    outline: none;
  }
  & .PhoneInputCountrySelectArrow {
    opacity: 1;
    margin-left: 8px;
    height: 8px;
    width: 8px;
    border-width: 0 2px 2px 0;
    margin-bottom: 4px;
  }

  & > div {
    padding: 0 8px 0 12px;
    background: #ffffff;
    background: transparent;
    margin-right: 0;
  }

  & > div:after {
    position: absolute;
    border-right: 1px solid #a3a3a3;
    height: 50%;
    display: none;
    align-items: center;
    content: "";
    padding-left: 12px;
    right: 0;
  }

  & > input {
    padding: 8px 14px 8px 0;
    height: 46px;
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    width: 100%;
    box-sizing: border-box;
    flex: 1;
    border: unset;
    background: transparent;
    outline: none;
  }

    & > input:placeholder {
      color: #8D8D8D;
   }
`;
